import * as betprofessor from './NextToJumpBanner.styles.betprofessor';
import * as betroyale from './NextToJumpBanner.styles.betroyale';
import * as fiestabet from './NextToJumpBanner.styles.fiestabet';
import * as goldenrush from './NextToJumpBanner.styles.goldenrush';
import * as juicybet from './NextToJumpBanner.styles.juicybet';
import * as puntcity from './NextToJumpBanner.styles.puntcity';
import * as puntgenie from './NextToJumpBanner.styles.puntgenie';
import * as questbet from './NextToJumpBanner.styles.questbet';
import * as sterlingparker from './NextToJumpBanner.styles.sterlingparker';
import * as vikingbet from './NextToJumpBanner.styles.vikingbet';
import * as volcanobet from './NextToJumpBanner.styles.volcanobet';
import * as junglebet from './NextToJumpBanner.styles.junglebet';
import * as betstride from './NextToJumpBanner.styles.betstride';
import * as forsport from './NextToJumpBanner.styles.forsport';
import * as oldgill from './NextToJumpBanner.styles.oldgill';
import * as sugarcastle from './NextToJumpBanner.styles.sugarcastle';
import * as buffalobet from './NextToJumpBanner.styles.buffalobet';
import * as titanbet from './NextToJumpBanner.styles.titanbet';
import * as templebet from './NextToJumpBanner.styles.templebet';
import * as bet777 from './NextToJumpBanner.styles.bet777';
import * as goldenbet888 from './NextToJumpBanner.styles.goldenbet888';
import * as slambet from './NextToJumpBanner.styles.slambet';
import * as gigabet from './NextToJumpBanner.styles.gigabet';
import * as betgalaxy from './NextToJumpBanner.styles.betgalaxy';
import * as hyperbet from './NextToJumpBanner.styles.hyperbet';
import * as chromabet from './NextToJumpBanner.styles.chromabet';
import * as bet575 from './NextToJumpBanner.styles.bet575';
import * as betblast from './NextToJumpBanner.styles.betblast';
import * as magnumbet from './NextToJumpBanner.styles.magnumbet';
import * as pyramidbet from './NextToJumpBanner.styles.pyramidbet';

import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  junglebet,
  betstride,
  forsport,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  templebet,
  bet777,
  goldenbet888,
  slambet,
  gigabet,
  betgalaxy,
  hyperbet,
  chromabet,
  bet575,
  betblast,
  magnumbet,
  pyramidbet,
};
